/** Fixed-position panel anchored to a trigger — shared math for modal/stacked UIs. */

export type PortalPanelBox = { top: number; left: number; width: number };

/** Diligence pack editor / hub modal combobox — matches legacy SearchableCombobox layout. */
export const computeHubModalComboboxPanelBox = (
  b: DOMRectReadOnly,
  vw: number,
  vh: number,
): PortalPanelBox => {
  const margin = 4;
  const width = Math.min(Math.max(b.width, 200), vw - margin * 2);
  let left = b.left;
  if (left + width + margin > vw) {
    left = Math.max(margin, vw - width - margin);
  }
  const spaceBelow = vh - b.bottom - margin;
  const spaceAbove = b.top - margin;
  const top =
    spaceBelow < 120 && spaceAbove > spaceBelow
      ? Math.max(margin, b.top - 2 - 280)
      : b.bottom + 2;
  return { top, left, width };
};

/** Report theme Google font picker — matches legacy ReportThemeGoogleFontCombobox layout. */
export const computeReportThemeFontComboboxPanelBox = (
  b: DOMRectReadOnly,
  vw: number,
  vh: number,
): PortalPanelBox => {
  const margin = 8;
  const width = Math.min(Math.max(b.width, 200), Math.max(200, vw - margin * 2));
  let left = b.left;
  if (left + width + margin > vw) {
    left = Math.max(margin, vw - width - margin);
  }
  const spaceBelow = vh - b.bottom - margin;
  const spaceAbove = b.top - margin;
  const preferredMax = 280;
  let top = b.bottom + 4;
  if (spaceBelow < 120 && spaceAbove > spaceBelow) {
    top = Math.max(margin, b.top - 4 - preferredMax);
  }
  return { top, left, width };
};
